<template>
  <card>
    <template #header>
      <div class="flex gap-1 items-center">
        <l-select
          v-model="active"
          class="
            font-medium text-blue dark:text-white leading-none
            field:border-0 field:shadow-none field:!pr-2
            label:sr-only
            -ml-4 -my-1.5
          "
          autofocus
          inline
          :items="items"
          label="Job type"
        />
        <term :text="active.term"/>
      </div>
    </template>

    <template v-for="sparkline in sparklines">
      <sparkline-job-stat
        v-if="sparkline.field == active.field"
        :key="sparkline.field"
        :school="school"
        :title="sparkline.title"
        :field="sparkline.field"
        size="md"
      />
    </template>
  </card>
</template>

<script setup>
import Card from "@/components/cards/Card.vue"
import LSelect from "@/components/inputs/LSelect.vue"
import SparklineJobStat from "@/components/sparklines/SparklineJobStat.vue"
import Term from "@/components/Term.vue"
import terms from "@/terms"
import { ref } from "vue"

defineProps({
  school: { type: Object, required: true },
})

const sparklines = [
  {
    title: "Public service",
    field: "public_service_percent",
    term: terms.publicService,
  },
  {
    title: "Federal clerkships",
    field: "federal_clerkship_percent",
    term: terms.federalClerkship,
  },
  {
    title: "National firms",
    field: "national_firm_percent",
    term: terms.nationalFirms,
  },
  {
    title: "Regional firms",
    field: "regional_firm_percent",
    term: terms.regionalFirms,
  },
  {
    title: "Small firms",
    field: "small_firm_percent",
    term: terms.smallFirms,
  },
]

const active = ref(sparklines[0])

const items = sparklines.map(sparkline => [sparkline, sparkline.title])
</script>
